module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("khXa1"))).then(() => module.bundle.root('1iHdE'));